// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Call proxy to API v1 with access token exchange POST /api/v1/proxy/to-v1/with-access-token */
export async function toV1AccessToken(
  body: API.ApiProxyParamsDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/proxy/to-v1/with-access-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Call proxy to API v1 with access token exchange POST /api/v1/proxy/to-v1/with-basic-token */
export async function toV1BasicToken(
  body: API.ApiProxyParamsDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/proxy/to-v1/with-basic-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Call proxy to API v1 with access token exchange POST /api/v1/proxy/to-v2/with-access-token */
export async function toV1AccessToken2(
  body: API.ApiProxyParamsDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/proxy/to-v2/with-access-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Call proxy to API v1 with access token exchange POST /api/v1/proxy/to-v2/with-basic-token */
export async function toV1BasicToken2(
  body: API.ApiProxyParamsDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/proxy/to-v2/with-basic-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
